import React from 'react';
import Shop from '../Shop/Shop';

const Home = () => {
    return (
        <div>
            <Shop/> 
            
        </div>
    );
};

export default Home;